/**
 * @Note: This component is used to load the font faces for the application.
 * It is not part of the design system or the Chakra style config system.
 */
import React from 'react';

import { useTheme } from '@chakra-ui/react';
import { Global } from '@emotion/react';

import { getFontFaceStyles } from './helpers';

export const Fonts = () => {
  const { name } = useTheme();
  const fontFaceStyles = getFontFaceStyles(name);
  return <Global styles={fontFaceStyles} />;
};
